import { Box } from 'braid-design-system';

import { LoginPrompt, type LoginPromptProps } from './LoginPrompt';

import { loginBannerBackgroundImgStyle } from './LoginPromptBanner.css';

type Props = {
  hasBlurryBackground?: boolean;
} & LoginPromptProps;

export const LoginPromptBanner = ({
  hasBlurryBackground,
  ...loginPromptProps
}: Props) => {
  if (hasBlurryBackground) {
    return (
      <Box background="body">
        <Box
          className={loginBannerBackgroundImgStyle}
          paddingY="xxlarge"
          padding="large"
        >
          <Box borderRadius="large" overflow="hidden" boxShadow="small">
            <LoginPrompt {...loginPromptProps} />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box borderRadius={{ tablet: 'large' }} overflow="hidden">
      <LoginPrompt {...loginPromptProps} />
    </Box>
  );
};
